// shows the group's current rate schedule information.
export class CurrentBillingPlan extends HTMLElement {
  constructor() {
    super();
  }

  async loadData(){
    let url = `/admin/rate_schedules/${this.rateScheduleId}/card_editor_data`
    let res = await fetch(url);
    this.data = await res.json();
    //console.log('CurrentBillingPlan data: ',this.data)
  }

  async connectedCallback() {
    this.innerHTML = `
      <template id="additional_charges_template">      
        <div class="well">
          <table class="pricing-table">
            <colgroup>
              <col class="col-headers" />
              <col class="col-data" />
            </colgroup>
            <thead>
            </thead>
          </table>
        </div>
      </template>

      <div id="current_billing_plans_container" class="row"></div>
    ` 

    this.rateScheduleId = this.getAttribute('rateScheduleId')
    // rateScheduleId can be "null" if this group has no rate schedule.
    if (isNaN(this.rateScheduleId)) {
      this.renderNoData()
    }
    else {
      await this.renderData()
    }
  }

  async renderData() {
    await this.loadData()

    const billing_plans_container = this.querySelector('#current_billing_plans_container');
    if (billing_plans_container){
      this.data.map(rate_schedule => {
        billing_plans_container.appendChild(new CurrentBillingPlanInfo(rate_schedule))        
      })
    }
  }

  renderNoData() {
    let html = `<h3>No rate schedule has been selected.</h3>`
    const billing_plans_container = this.querySelector('#current_billing_plans_container');
    billing_plans_container.innerHTML = html
  }
}
customElements.define('current-billing-plan', CurrentBillingPlan)

import {RateScheduleCardBase} from 'admin/accounting/rate_schedule_card_base'

/*
  Displays information about the current rate schedule for the group editor.
*/
export class CurrentBillingPlanInfo extends RateScheduleCardBase {
  constructor(plan) {
    super(plan);
  }

  generate_included_features() {
    let html = '<div class="well">'
    html += '<strong>Features:</strong><ul>'

    this.rateSchedule.included_items().map(charge => {
      html += `<li>${charge.data.description}</li>`
    })

    html += '</ul></div>'

    return html;
  }

  generate_price_html() {
    let price = this.rateSchedule.get_base_price()
    price = numeral( price ).format('$0,0');

    let html = '<div class="well">'
    html += '<strong>Price:</strong><ul>'

    html += `<li>Monthly fee of <span class="price">${price}</span> plus additional usage.</li>`

    html += '</ul></div>'
    return html
  }
  
  connectedCallback() {
    const included_features = this.generate_included_features();
    const template = this.generate_additional_charges_template();
    const price = this.generate_price_html()

    this.innerHTML = `
      <div class="row-margin-10">
        <div class="panel panel-default light-border">
          <div class="panel-heading" style="display:flex; justify-content:space-between">
            <div>
              <span class="h3 color_muted">Current Plan:</span>&nbsp;
              <span class="h3">${this.rs().rate_schedule_name}</span>
            </div>

            <div>
              <span class="h3 color_muted">Collection:</span>&nbsp;
              <span class="h3">${this.rs().rate_schedule_group_name}</span>
            </div>
            

            <a 
              href="/admin/prices"
              class=""
              >
              Pricing Plans
            </a>
          </div>
          <div class="panel-body">
            ${price}
            ${included_features}
            ${template}
          </div> <!-- panel body -->
          
          <div class="panel-footer">
            <div class="d-flex">
              <div class="flex-auto">
              </div>
            </div>
          </div> <!-- panel footer -->
        </div>
      </div> 
    `  

    const modal_template = this.querySelector('#modal_template');
    const node = modal_template.content.cloneNode(true)
    this.querySelector('.panel-body').appendChild(node)  

  }
}
customElements.define('current-billing-plan-info', CurrentBillingPlanInfo)


